import type { ValidationResult } from '@idem/tipos/validation-result.type';
import type { ValidationOptions } from '@idem/tipos/validation-options.type';

export const validateNoSpaces = (
  options: ValidationOptions & ValidationResult,
): ValidationResult => {
  if (options.code) {
    return options;
  }
  if (/\s/.test(options.value)) {
    return {
      ...options,
      code: 'no-spaces',
      message: fieldName => `${fieldName} no puede contener espacios.`,
    };
  }
  return options;
};
